import React from 'react';
import styled from 'styled-components';

import Filter from './Filter';

import FiltersContext from 'contexts/Filters';

const Section = styled.div`
  display: flex;
  align-items: start;
  justify-items: stretch;
`;


class Filters extends React.Component {
	state = {
	  open: null
	}

	openHandler = open => this.setState({ open })

	render() {
	  return (
	    <FiltersContext.Consumer>
	      {({
	        filters,
	        filterOpenHandler,
	        filterCheckHandler,
	        filterRangeHandler,
	      }) => (
	        <Section>
	          {Object.keys(filters).map(filterId => (
	            <Filter
	              key={filterId}
	              id={filterId}
	              {...filters[filterId]}
	              open={filterId === this.state.open}
	              openHandler={this.openHandler}
	              checkHandler={filterCheckHandler}
	              filterOpenHandler={() => filterOpenHandler(filterId)}
	              rangeHandler={filterRangeHandler}
	            />
	          )
	          )}
	        </Section>
	      )}
	    </FiltersContext.Consumer>
	  );
	}
}

export default Filters;
